(function () {
  'use strict';

  angular
    .module('app.stores-service', [])

    /* @ngInject */
    .factory('StoresService', ["$filter", "DateService", function ($filter, DateService) {
      var address;

      return {
        setAddress: function (value) {
          address = value;
        },
        getAddress: function () {
          return address;
        },
        getOpeningHours: function (point, days, strOneTime, strTwoTimes, strClosed) {
          if (point.OpeningHours[0].Date) {
            var tmp = [];
            _.each(point.OpeningHours, function (day, i) {
              var obj = {
                day: days[i]
              };

              if (day.IsOpen) {
                var date, format, amStart, amEnd, pmStart, pmEnd;
                date = DateService.stringToDate(day.Date1Start);
                format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                amStart = $filter('date')(date, format);

                date = DateService.stringToDate(day.Date1End);
                format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                amEnd = $filter('date')(date, format);

                date = DateService.stringToDate(day.Date2Start);
                if (date.getFullYear() !== 2001 && date.getFullYear() !== 1901 && date.getFullYear() !== 1) {
                  format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                  pmStart = $filter('date')(date, format);

                  date = DateService.stringToDate(day.Date2End);
                  format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                  pmEnd = $filter('date')(date, format);
                }

                obj.value = !pmStart ? $filter('format')(strOneTime, amStart, amEnd) : $filter('format')(strTwoTimes, amStart, amEnd, pmStart, pmEnd);
                obj.value = day.Exception ? obj.value + ' <strong>' + day.Exception + '</strong>' : obj.value;
              } else {
                obj.value = day.Exception ? '<strong>' + day.Exception + '</strong>' : strClosed;
              }
              tmp.push(obj);
            });
            point.OpeningHours = tmp;
          }
        }
      };
    }]);

})();
